import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_5 = { class: "header-right-side d-flex align-items-center flex-nowrap justify-content-center justify-content-md-end" }
const _hoisted_6 = { class: "dropdown profile-dropdown balance-item d-flex align-items-center" }
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = { class: "title balance-title ms-10 ms-lg-15" }
const _hoisted_9 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_10 = { class: "text-body-emphasis fw-semibold fs-13 balance-label" }
const _hoisted_11 = { class: "dropdown profile-dropdown" }
const _hoisted_12 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "title d-none d-lg-block ms-10 ms-lg-15 user-info" }
const _hoisted_14 = {
  class: "d-block fw-bold mb-5 mb-md-8 text-truncate",
  style: {"font-size":"12px"}
}
const _hoisted_15 = ["title"]
const _hoisted_16 = {
  class: "d-block mb-5 mb-md-8",
  style: {"font-size":"10px","font-style":"italic"}
}
const _hoisted_17 = { class: "balances-modal-content" }
const _hoisted_18 = { class: "balances-modal-header d-flex align-items-center justify-content-between" }
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = { class: "balances-modal-body" }
const _hoisted_21 = { class: "balance-row d-flex justify-content-between align-items-center" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "ms-10" }
const _hoisted_24 = { class: "balance-row d-flex justify-content-between align-items-center" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "ms-10" }
const _hoisted_27 = { class: "balance-row d-flex justify-content-between align-items-center" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { class: "ms-10" }

import { ref, onMounted, inject, computed, onUpdated, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import stateStore from "../../utils/store";
import { formatNumber, checkSessionValidate } from "../../utils/function";
import axios from 'axios';
import router from '../../router/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const backApi = inject('back');
const { t } = useI18n();

const isSticky = ref(false);

const refreshKey = ref(0);

const userRole = computed(() => {
  refreshKey.value;
  return localStorage.getItem('role') || '';
});
const userToken = computed(() => {
  refreshKey.value;
  return localStorage.getItem('login_token') || '';
});
const organizationCode = computed(() => {
  refreshKey.value;
  return localStorage.getItem('organization_code') || '';
});
const userCode = computed(() => {
  refreshKey.value;
  return localStorage.getItem('code') || '';
});
const organizationName = computed(() => {
  refreshKey.value;
  return localStorage.getItem('organization_name') || '';
});
const userName = computed(() => {
  refreshKey.value;
  return localStorage.getItem('name') || '';
});
const userEmail = computed(() => {
  refreshKey.value;
  return localStorage.getItem('email') || '';
});
const accountSize = computed(() => {
  refreshKey.value;
  return parseFloat(localStorage.getItem('account_size') || '0');
});
const personalAccountStatus = computed(() => {
  refreshKey.value;
  return localStorage.getItem('personnal_account_status') || '';
});

// === ÉTATS RÉACTIFS POUR LES SOLDES ===
const balance = ref('0');
const collect = ref('0');
const transfert = ref('0');
const mainBalance = ref('0');



const showBalancesModal = ref(false);

const toggleBalancesModal = () => {
  showBalancesModal.value = !showBalancesModal.value;
};

const closeBalancesModal = () => {
  showBalancesModal.value = false;
};

const stateStoreInstance = computed(() => stateStore);

function formatDateEn(value: Date, d = 0) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate() + d;
    day = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + day;
  }
}

function getFile() {
  window.open(`/izypay.pdf`, "_blank");
}

// === FONCTIONS DE RÉCUPÉRATION DES SOLDES ===
const getBalanceAvailable = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/available', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    balance.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getCollectBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/collect', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    collect.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getTransfertBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/payout', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    transfert.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getTransfertBalancePerso = () => {
  const token = userToken.value;
  const code = userCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/main', {
    user: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    transfert.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getMainBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/main', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    mainBalance.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const handleLogout = () => {
  localStorage.clear();
  window.dispatchEvent(new CustomEvent('user-logout'));
  window.dispatchEvent(new Event('storage'));
  router.push('/');
};

const loadAllData = () => {
  const token = userToken.value;
  if (!token) {
    balance.value = '0';
    collect.value = '0';
    transfert.value = '0';
    mainBalance.value = '0';
    return;
  }

  if (userRole.value === "SUPERADMIN") {
    balance.value = '0';
    collect.value = '0';
    transfert.value = '0';
    mainBalance.value = '0';
    return;
  }

  if (checkSessionValidate()) {
    getBalanceAvailable();
    getCollectBalance();
    getMainBalance();
    if (accountSize.value > 0 && personalAccountStatus.value === "ACTIVE") {
      getTransfertBalancePerso();
    } else {
      getTransfertBalance();
    }
  }
};

let intervalId: number | null = null;

const startInterval = () => {
  if (intervalId) {
    clearInterval(intervalId);
  }

  intervalId = setInterval(() => {
    if (localStorage.getItem('login_token') !== null) {
      if (checkSessionValidate() && userRole.value !== "SUPERADMIN") {
        getBalanceAvailable();
        getCollectBalance();
        getMainBalance();
        if (accountSize.value > 0 && personalAccountStatus.value === "ACTIVE") {
          getTransfertBalancePerso();
        } else {
          getTransfertBalance();
        }
      }
    }
  }, 30000);
};

const onUserLogin = () => {
  refreshKey.value++;
  loadAllData();
};

const onUserLogout = () => {
  refreshKey.value++;
  balance.value = '0';
  collect.value = '0';
  transfert.value = '0';
  mainBalance.value = '0';
  showBalancesModal.value = false;
};

const onStorageChange = (e: StorageEvent) => {
  if (e.key === 'login_token' || e.key === 'role' || e.key === 'organization_code') {
    refreshKey.value++;
    loadAllData();
  }
};

const onScroll = () => {
  let scrollPos = window.scrollY;
  isSticky.value = scrollPos >= 100;
};

// === CYCLE DE VIE ===
onMounted(() => {
  loadAllData();
  startInterval();

  window.addEventListener('user-login', onUserLogin);
  window.addEventListener('user-logout', onUserLogout);
  window.addEventListener('storage', onStorageChange);
  window.addEventListener('scroll', onScroll);
});

onUpdated(() => {
  const currentToken = localStorage.getItem('login_token');
  if (currentToken && currentToken !== userToken.value) {
    refreshKey.value++;
    loadAllData();
  }
});

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
  window.removeEventListener('user-login', onUserLogin);
  window.removeEventListener('user-logout', onUserLogout);
  window.removeEventListener('storage', onStorageChange);
  window.removeEventListener('scroll', onScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (stateStoreInstance.value.show == true)
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky.value },
    ]),
          id: "header"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
                  id: "header-burger-menu",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (stateStoreInstance.value.onChange && stateStoreInstance.value.onChange(...args)))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: getFile,
                  class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "flaticon-idea" }, null, -1)
                ]))])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: toggleBalancesModal,
                    class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
                    type: "button",
                    "aria-expanded": showBalancesModal.value
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", {
                      class: "icon text-primary rounded-circle text-center balance-icon",
                      style: {"border":"1px solid blueviolet"}
                    }, [
                      _createElementVNode("i", { class: "flaticon-money fs-2x" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(mainBalance.value) + " XOF", 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('header.mainBalance')), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["balance-chevron ms-6", { 'is-open': showBalancesModal.value }])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(showBalancesModal.value ? 'ph-bold ph-caret-up' : 'ph-bold ph-caret-down')
                      }, null, 2)
                    ], 2)
                  ], 8, _hoisted_7)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown email-dropdown" }, null, -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: "/account-settings",
                    class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_12, [
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                          src: _imports_0,
                          class: "rounded flex-shrink-0",
                          width: "44",
                          height: "44",
                          alt: "admin"
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(organizationName.value), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, null, -1)),
                          _createElementVNode("span", {
                            class: "d-block text-body-emphasis fw-semibold fs-13 text-truncate",
                            title: userEmail.value
                          }, _toDisplayString(userEmail.value), 9, _hoisted_15),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(userRole.value), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showBalancesModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "balances-modal-overlay",
            onClick: _withModifiers(closeBalancesModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.$t('header.otherBalances')), 1),
                _createElementVNode("button", {
                  class: "bg-transparent border-0 lh-1",
                  onClick: closeBalancesModal
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "ph-bold ph-x fs-4" }, null, -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", {
                      class: "icon text-danger rounded-circle text-center balance-icon-sm",
                      style: {"border":"1px solid red"}
                    }, [
                      _createElementVNode("i", { class: "ph-duotone ph-shield-plus" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('header.availableBalance')), 1)
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(balance.value) + " XOF", 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", {
                      class: "icon text-success rounded-circle text-center balance-icon-sm",
                      style: {"border":"1px solid green"}
                    }, [
                      _createElementVNode("i", { class: "flaticon-money" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('header.collectBalance')), 1)
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(collect.value) + " XOF", 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", {
                      class: "icon text-primary rounded-circle text-center balance-icon-sm",
                      style: {"border":"1px solid blueviolet"}
                    }, [
                      _createElementVNode("i", { class: "flaticon-money" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('header.transferBalance')), 1)
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(transfert.value) + " XOF", 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})